import { useMemo } from "react";
import { observer } from "mobx-react";
import { getProfitColor } from "@utils";
import { useEstimateStructure, ValueCell } from "@tools";
import { useTheme } from "@material-ui/core/styles";

export const PriceModifierCompanyProfitabilityCell = observer((cellProps) => {
  const theme = useTheme();
  const structure = useEstimateStructure();
  const { companyBreakdownMaterialProfitability } = structure;
  
  const color = useMemo(() => (
    getProfitColor(companyBreakdownMaterialProfitability, theme)
  ), [companyBreakdownMaterialProfitability, theme]);
  
  return <ValueCell
    size="medium"
    style={{color}}
    {...cellProps}
  />
})